import { render, staticRenderFns } from "./DishStatistics.vue?vue&type=template&id=0d29799c"
import script from "./DishStatistics.vue?vue&type=script&lang=js"
export * from "./DishStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports